import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SimpleMDE from 'react-simplemde-editor'
import { FormattedMessage } from 'react-intl'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import CommentLabelDropdown from './CommentLabelDropdown'
import MarkdownLabel from '../MarkdownLabel'
import ModalComponent from '../ModalComponent'
import UserName from '../UserName'

import {
  resolveComment,
  openComment,
  deleteComment,
  editComment
} from '../../../actions/comments'
import labels from '../../../utils/commentlabels'
import { simpleMDEOptions } from '../../../utils/index'
import { getCommentResourceType } from '../../../utils/quest'
import { resolved } from '../../../utils/messages'
import { getUserDisplayName } from '../../../utils/name'

export default class PublishedComment extends Component {
  constructor(props) {
    super(props)

    this.state = {
      comment: props.comment.body,
      isEditing: false,
      isDirty: false
    }

    this.onDeleteClickBound = this.onDeleteClick.bind(this)
    this.onCancelClickBound = this.onCancelClick.bind(this)
    this.onEditCommentClickBound = this.onEditCommentClick.bind(this)
    this.onEditClickBound = this.onEditClick.bind(this)
    this.resolveCommentBound = this.resolveComment.bind(this)
    this.openCommentBound = this.openComment.bind(this)
    this.hideModalBound = this.hideModal.bind(this)
    this.onDeleteClickBound = this.onDeleteClick.bind(this)
    this.onActualDeleteClickBound = this.onActualDeleteClick.bind(this)
    this.handleCommentChangeBound = this.handleCommentChange.bind(this)
    this.onLabelChangeBound = this.onLabelChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.comment.id !== nextProps.comment.id) {
      this.setState({
        isEditing: false
      })
    }
  }

  render() {
    const { comment, user } = this.props
    var edited = comment.updated_at !== comment.created_at
    var cssClass = comment.status === 1 ? 'resolved' : 'open'

    if (this.props.showingResolvedComments) {
      cssClass += ' showanyway'
    }

    if (this.state.isEditing) {
      cssClass += ' isEditing'
    }

    const options = Object.assign({}, simpleMDEOptions)
    options.autofocus = true
    options.initialValue = comment.body

    return (
      <div className="published-comment">
        {this.state.isEditing && (
          <div className="comment-header">
            <div className="comment-icon edit" />
            <div className="comment-header-text h4">Edit Comment</div>
          </div>
        )}
        <li className={cssClass}>
          <div className="shadow">
            <div className="comment-body-header">
              <div className="comment-user-photo">
                {comment.user.photo_url && (
                  <div className="user-photo-wrapper">
                    <img src={comment.user.photo_url} />
                  </div>
                )}
              </div>
              <div className="comment-user-info">
                <UserName
                  activeCertifications={comment.user.active_certifications}
                  userId={`published-comment-${comment.id}-user-${comment.user.id}`}
                  rebuild
                >
                  <div className="comment-user-name">
                    {getUserDisplayName(comment.user)}
                  </div>
                </UserName>
                <div className="commented-on" style={{ marginLeft: '7px' }}>
                  <FormattedMessage
                    id={'Comment.CommentedOn'}
                    defaultMessage={'commented on'}
                  />
                </div>
                {!this.state.isEditing && (
                  <div className="comment-label">{comment.label}</div>
                )}
                {this.state.isEditing && (
                  <div className="labels">
                    <CommentLabelDropdown
                      labels={labels[this.props.section]}
                      selectedValue={comment.label}
                      onChange={this.onLabelChangeBound}
                      type="Published"
                    />
                  </div>
                )}
                <div className="comment-date">
                  <OEComponents.DateFormatter
                    date={comment.updated_at}
                    includeTime={false}
                  />
                  {' at '}
                  <OEComponents.Time time={comment.updated_at} />
                  {edited ? ' (edited)' : ''}
                </div>
              </div>
              {comment.status === 1 && (
                <div className="comment-resolve-action resolved">
                  {resolved}&nbsp;
                  <div className="pipechar">|</div>{' '}
                  <div className="reopen" onClick={this.openCommentBound}>
                    <FormattedMessage
                      id={'Comment.Reopen'}
                      defaultMessage={'Re-open'}
                    />
                  </div>
                </div>
              )}
              {comment.status !== 1 && (
                <div
                  className="comment-resolve-action unresolved"
                  onClick={this.resolveCommentBound}
                >
                  <FormattedMessage
                    id={'Comment.MarkResolved'}
                    defaultMessage={'Mark Resolved'}
                  />
                </div>
              )}
            </div>

            {!this.state.isEditing && (
              <MarkdownLabel
                additionalCssClasses="comment-body"
                value={comment.body}
              />
            )}

            {this.state.isEditing && (
              <div className="edit-comment-area">
                <SimpleMDE
                  options={options}
                  onChange={this.handleCommentChangeBound}
                />
                <div className="actions">
                  <div
                    className={
                      this.state.isDirty && this.state.comment.length > 0
                        ? 'button save active btn-primary-small'
                        : 'button disabled save btn-primary-small'
                    }
                    onClick={this.onEditCommentClickBound}
                  >
                    Post Changes
                  </div>
                  <div className="cancel-add" onClick={this.onCancelClickBound}>
                    Cancel
                  </div>
                </div>
                <div className="notification caption1">
                  Posting your changes will notify the active quest authors and
                  anyone else that has posted a comment on this section.
                </div>
              </div>
            )}

            {!this.state.isEditing && comment.user.id === user.id && (
              <div className="existing-comment-actions">
                <div className="edit" onClick={this.onEditClickBound}></div>
                <div className="pipe"></div>
                <div className="trash" onClick={this.onDeleteClickBound}></div>
              </div>
            )}
          </div>

          <ModalComponent
            ref="deleteCommentModal"
            klass="modal delete-comment-modal"
            modalId="commentDeleteModal"
            headingKlass="modal-heading h3"
            logoKlass="logo delete-comment"
            headingText="Delete comment?"
            bodyText=""
            primaryButtonText="Yes, Delete"
            secondaryButtonText="Cancel"
            primaryButtonAction={this.onActualDeleteClickBound}
            secondaryButtonAction={this.hideModalBound}
          />
        </li>
      </div>
    )
  }

  handleCommentChange(val) {
    this.setState(() => {
      return {
        comment: val,
        isDirty: true
      }
    })
  }

  onLabelChange() {
    this.setState({ isDirty: true })
  }

  onDeleteClick() {
    this.refs.deleteCommentModal.refs.modal.show()
  }

  onCancelClick() {
    this.setState(() => {
      return {
        isEditing: false,
        isDirty: false
      }
    })
    this.render()
  }

  onEditClick() {
    this.setState({ isEditing: true })
  }

  onActualDeleteClick() {
    const { comment, dispatch } = this.props
    dispatch(
      deleteComment(
        comment.resource_id,
        getCommentResourceType(comment),
        comment.id
      )
    )
    this.hideModal()
  }

  onEditCommentClick() {
    const { comment, dispatch } = this.props
    var labels = document.getElementById('commentLabelPublished')
    var selectedLabel = labels.options[labels.selectedIndex].value
    dispatch(
      editComment(
        comment.resource_id,
        getCommentResourceType(comment),
        comment.id,
        this.state.comment,
        selectedLabel
      )
    )
    this.setState({ isEditing: false })
  }

  resolveComment() {
    const { comment, dispatch } = this.props
    dispatch(
      resolveComment(
        comment.resource_id,
        getCommentResourceType(comment),
        comment.id
      )
    )
  }

  openComment() {
    const { comment, dispatch } = this.props
    dispatch(
      openComment(
        comment.resource_id,
        getCommentResourceType(comment),
        comment.id
      )
    )
  }

  hideModal() {
    this.refs.deleteCommentModal.refs.modal.hide()
  }
}

PublishedComment.propTypes = {
  dispatch: PropTypes.func,
  user: PropTypes.object,
  comment: PropTypes.object.isRequired,
  quest: PropTypes.object.isRequired,
  showingResolvedComments: PropTypes.bool,
  section: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/mini/comments/PublishedComment.js